import React, { useEffect, useRef, useState } from "react";
import { Typography } from "@mui/material";
import { StyledDropDateChip, StyledStack, StyledTooltip } from "./styles";
import SchedulerBarTooltip from "./SchedulerBarTooltip";

const MIN_LABEL_HEIGHT = 18;

export const SchedulerBar = ({
  id,
  opacity = 0.1,
  workOrder,
  customer,
  partName,
  startDate,
  revenue,
  hours,
  weeklyHourGoal,
  weeklyRevenueGoal,
  showLabels = false,
  suggested = false,
  isDragging = false,
  started = false,
  isActive = false,
  targetDate = null,
  view = 0,
}) => {
  const ref = useRef(null);
  const [fits, setFits] = useState(false);

  useEffect(() => {
    if (!showLabels || !ref.current) {
      setFits(false);
      return;
    }
    const obs = new ResizeObserver(([entry]) => {
      setFits(entry.contentRect.height >= MIN_LABEL_HEIGHT);
    });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [showLabels]);

  const title = (
    <SchedulerBarTooltip
      workOrder={workOrder}
      customer={customer}
      partName={partName}
      startDate={startDate}
      hours={hours}
      revenue={revenue}
      weeklyHourGoal={weeklyHourGoal}
      weeklyRevenueGoal={weeklyRevenueGoal}
    />
  );

  return (
    <StyledTooltip
      title={title}
      enterDelay={1000}
      enterNextDelay={1000}
      open={isActive || isDragging ? false : undefined}
      disableHoverListener={isActive || isDragging}
      disableFocusListener
      followCursor
    >
      <div style={{ width: "100%", height: "100%", position: "relative" }}>
        <StyledStack
          ref={ref}
          {...(isDragging ? { id: "HubScheduler-isDragging" } : {})}
          key={id}
          opacity={opacity}
          isDragging={isDragging}
          isDisabled={!!started}
          suggested={suggested}
          view={view}
        >
          {showLabels && fits && (
            <Typography
              variant="caption"
              noWrap
              sx={{
                fontSize: "12px",
                fontColor: "hubColors.black",
                textOverflow: "ellipsis",
                mx: "auto",
              }}
            >
              {workOrder}
            </Typography>
          )}
        </StyledStack>
        {isDragging && targetDate && (
          <StyledDropDateChip>{targetDate}</StyledDropDateChip>
        )}
      </div>
    </StyledTooltip>
  );
};

export default SchedulerBar;
